<template>
  <div v-show="isVisible">
    <transition name="fade" appear>
      <div class="jcxy-modal-overlay" :style="{zIndex: getZindex(1)}"></div>
    </transition>
    <transition name="pop" appear>
      <div class="jcxy-modal" :class="{'big': isBig, 'isPc': !$utils.isMobile()}" :style="{zIndex: getZindex(2)}">
        <div class="jcxy-modal-trans"></div>
        <img class="jcxy-modal-icon" src="./assets/dialog_icon.svg" alt="">
        <div class="jcxy-modal-container">
          <div @click="cancel" v-show="isShowCloseBtn" class="jcxy-modal-closeBtn">
            <img src="./assets/close_icon.svg" />
          </div>
          <div class="jcxy-modal-title">
            <div>{{title}}</div>
          </div>
          <div class="jcxy-modal-message" :style="{textAlign: textAlign}">{{message}}</div>
          <div v-show="showCancelBtn" class="jcxy-modal-btn jcxy-modal-cancel-btn" @click="cancel">{{cancelBtnText}}</div>
          <div v-show="showConfirmlBtn" class="jcxy-modal-btn jcxy-modal-confirm-btn" @click="confirm">{{confirmlBtnText}}</div>
          <!-- <div>知道了</div> -->
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'jcxy-dialog',
  props: {
    // title: {
    //   type: String,
    //   default: ''
    // },
    // message: {
    //   type: String,
    //   default: ''
    // },
    // textAlign: {
    //   type: String,
    //   default: 'left'
    // },
    // visible: {
    //   type: Boolean,
    //   default: false
    // },
    // showCancelBtn: {
    //   type: Boolean,
    //   default: true
    // },
    // cancelBtnText: {
    //   type: String,
    //   default: '取消'
    // },
    // showConfirmlBtn: {
    //   type: Boolean,
    //   default: true
    // },
    // confirmlBtnText: {
    //   type: String,
    //   default: '确定'
    // },
  },
  data () {
    return {
      baseZindex: 2000,
      isVisible: false,
      isShowCloseBtn: false,
      resolve: null,
      reject: null,
      title: '提示',
      message: '',
      textAlign: 'left',
      isBig: false,
      showCancelBtn: true,
      cancelBtnText: '取消',
      showConfirmlBtn: true,
      confirmlBtnText: '确定'
    }
  },
  methods: {
    getZindex (num = 1) {
      const allElement = Array.from(document.all);
      const zIndexArray = []
      allElement.forEach((item) => {
        const itemZIndex = Number(window.getComputedStyle(item, null).getPropertyValue("z-index"))
        if(itemZIndex) {
          zIndexArray.push(itemZIndex)
        }
      })
      let maxZIndex = 0
      if(zIndexArray.length) {
        maxZIndex = Math.max(...zIndexArray)
      }
      return maxZIndex < this.baseZindex ? this.baseZindex + num : maxZIndex + num
    },
    open (cb) {
      this.isVisible = true
      typeof cb === "function" && cb.call(this, this);
      return new Promise((resolve, reject) => {
        this.reject = reject;
        this.resolve = resolve;
      });
    },
    confirm () {
      // this.$emit('confirm')
     this.resolve('confirm');
     this.hide()
    },
    cancel () {
      // this.$emit('cancel')
     this.reject('cancel');
     this.hide()
    },
    hide () {
      this.isVisible = false;
      const dom = document.getElementsByClassName('appContent')[0]
      // dom.style.position = 'static'
      dom.removeChild(this.$el);
      this.$destroy();
    }
  },
}
</script>

<style lang="scss" scope>
.jcxy-modal {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 20rem;
  min-height: 23rem;
  height: fit-content;
  /* overflow: hidden; */
  background: linear-gradient( 155deg, #C8E1F9 0%, #FFFFFF 51%);
  border-radius: 1.8rem;
  &-icon {
    position: absolute;
    top: -6rem;
    left: 50%;
    transform: translateX(-50%);
  }
  &-trans {
    background: rgba(255,255,255,0.4);
    border-radius: 1.8rem;
    border: 1px solid #FFFFFF;
    min-height: 23rem;
    height: fit-content;
    width: 20rem;
    box-sizing: border-box;
    transform: rotateZ(8deg);
    position: absolute;
    top: 0;
    left: 0;
  }
  &-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &-closeBtn {
    display: flex;
    position: absolute;
    z-index: 10;
    right: 0;
    top: 0;
    padding: 1rem;

    img {
      width: 2rem;
      height: 2rem;
    }
  }

  &-title {
    text-align: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 1.6rem;
    color: #3143C4;
    line-height: 1.9rem;
    padding-top: 4.8rem;
  }
  &-message {
    margin-top: 1.6rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 1.2rem;
    color: #666666;
    line-height: 1.4rem;
    padding: 0 1.2rem;
    margin-bottom: 2.4rem;
    display: flex;
    justify-content: center;
  }
  &-btn {
    margin: 0 1.2rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 1.4rem;
    color: #FFFFFF;
    line-height: 1.6rem;
    text-align: center;
    padding: 0.6rem 0;
    border-radius: 999rem;
    margin-top: 0.8rem;
  }
  &-confirm-btn {
    background: #3143C4;
  }
  &-cancel-btn {
    background: rgba(198,205,221,0.29);
    color: #7684AC;
  }

  &.big {
    width: calc(100% - 4rem);
    margin: auto 2rem;
    min-height: 80%;

    &.isPc {
      width: calc(500px - 4rem);
      margin: auto;
    }

    .jcxy-modal-trans {
      display: none;
    }

    .jcxy-modal-container {
      display: flex;
      flex-direction: column;
      padding-bottom: 2rem;
      box-sizing: border-box;

      .jcxy-modal-title {
        width: 100%;
        box-sizing: border-box;
      }

      .jcxy-modal-message {
        width: 100%;
        height: 0;
        flex-grow: 1;
        box-sizing: border-box;
        overflow-y: auto;
        font-size: 1.4rem;
        line-height: 2.2rem;
      }

      .jcxy-modal-btn {
        width: 17.6rem;
        margin: 0.8rem auto 0;
      }

      &>.jcxy-modal-btn:last-child {
        margin-top: 0;
      }
    }
  }
}
.jcxy-modal-overlay {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
}
</style>



// WEBPACK FOOTER //
// src/components/jcxy-dialog/jcxy-dialog.vue